import { Link } from 'react-router-dom'
import './BlogCard.css'

/**
 * Standard blog article card (image, category badge, meta, title, excerpt,
 * read-more) used on the /blog listing grid and the "Related Articles" strip
 * of the detail page. Expects a post already shaped by decoratePost().
 */
export default function BlogCard({ post }) {
  const to = `/blog/${post.slug ?? post.id}`
  return (
    <article className="bl-card">
      <Link to={to} className="bl-img-wrap" aria-label={post.title}>
        {post.img ? (
          <img className="bl-img" src={post.img} alt={post.title} loading="lazy" />
        ) : (
          /* An article with no cover used to leave a blank beige rectangle —
             now that astrologers write here, a missing cover is routine, so it
             falls back to the site's mark instead of a hole in the grid. */
          <span className="bl-img-fallback" aria-hidden="true">ॐ</span>
        )}
        <div className="bl-img-overlay" />
        <span className="bp-badge bl-badge-pos">{post.badge}</span>
      </Link>
      <div className="bl-body">
        <div className="bl-meta">
          {post.authorPhoto ? (
            <img className="bl-avatar bl-avatar-img" src={post.authorPhoto} alt="" loading="lazy" />
          ) : (
            <div className="bl-avatar">{(post.author?.[0] || 'R').toUpperCase()}</div>
          )}
          {post.author}
          <span className="bl-meta-dot" /> {post.date}
          <span className="bl-meta-dot" /> {post.readTime}
        </div>
        <h3 className="bl-title">
          <Link to={to}>{post.title}</Link>
        </h3>
        <p className="bl-excerpt">{post.excerpt}</p>
        <div className="bl-footer">
          <Link to={to} className="bl-read">
            Read More
            <svg className="bl-read-arrow" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M2 7H12M12 7L8 3M12 7L8 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>
      </div>
    </article>
  )
}

/** Grid placeholder while posts load. */
export function BlogCardSkeleton() {
  return (
    <article className="bl-card animate-pulse" aria-hidden="true">
      <div className="bl-img-wrap" style={{ background: 'rgba(180,83,9,.10)' }} />
      <div className="bl-body space-y-3">
        <div className="h-2.5 w-1/3 rounded" style={{ background: 'rgba(180,83,9,.10)' }} />
        <div className="h-4 w-5/6 rounded" style={{ background: 'rgba(180,83,9,.14)' }} />
        <div className="h-2.5 w-full rounded" style={{ background: 'rgba(180,83,9,.08)' }} />
        <div className="h-2.5 w-4/5 rounded" style={{ background: 'rgba(180,83,9,.08)' }} />
      </div>
    </article>
  )
}
